import { render, staticRenderFns } from "./DocumentListPage.vue?vue&type=template&id=be0d7a2e&scoped=true"
import script from "./DocumentListPage.vue?vue&type=script&lang=js"
export * from "./DocumentListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0d7a2e",
  null
  
)

export default component.exports